<template>
  <div>
    <div
      class="search_cond"
      style="display: flex; justify-content: space-between"
    >
      <div>
        报警类型:
        <el-select
          v-model="alarmType"
          placeholder="请选择报警类型"
          style="width: 200px; margin-right: 20px"
          :clearable="true"
        >
          <el-option
            v-for="item in ALARM_TYPE"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </div>
      <div>
        <el-button
          v-has-permission="[REMINDER_SETTING.ADD]"
          type="primary"
          icon="el-icon-plus"
          class="ml20 mt10 searchBtn"
          @click="addInfo"
        >
          添加
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          class="ml20 mt10 searchBtn"
        >
          搜索
        </el-button>
        <el-button icon="el-icon-search" @click="resetQuery"> 重置 </el-button>
      </div>
    </div>
    <rv-table
      ref="rvTableRef"
      :tableData="tableData"
      :totalNum="totalNum"
      :isLoading="isLoading"
      @getData="getData"
    >
      <el-table-column
        label="创建时间"
        prop="createTime"
        show-overflow-tooltip
      />
      <el-table-column
        label="报警类型"
        prop="alarmTypeName"
        show-overflow-tooltip
      />
      <el-table-column
        label="操作人"
        prop="operatorName"
        show-overflow-tooltip
      />
      <el-table-column label="备注" prop="remark" show-overflow-tooltip />
      <el-table-column label="操作" fixed="right" width="160">
        <template #default="scoped">
          <el-button
            v-has-permission="[
              REMINDER_SETTING.DETAIL,
              REMINDER_SETTING.UPDATE,
            ]"
            type="text"
            @click="updateData(scoped.row)"
          >
            查看
          </el-button>
          <el-button
            v-has-permission="[REMINDER_SETTING.DELETE]"
            type="text"
            style="color: red"
            @click="deleteData(scoped.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </rv-table>

    <!-- 新增详情对话框-->
    <reminder-setting ref="reminderSettingRef" @submit="handleQuery" />
  </div>
</template>

<script>
import { reminderQueryPage, reminderDelete } from "@/api/system/reminderConfig";
import { ALARM_TYPE } from "@/pages/system/reminder/config";
import { SYSTEM_SETTING } from "@/permission";
import ReminderSetting from "./components/reminderSetting.vue";

export default {
  name: "reminder-index",
  components: { ReminderSetting },
  mounted() {
    this.$refs.rvTableRef.initData();
  },
  data() {
    return {
      ALARM_TYPE,
      REMINDER_SETTING: SYSTEM_SETTING.REMINDER_SETTING,
      alarmType: undefined,
      tableData: [],
      totalNum: 0,
      isLoading: false,
    };
  },
  methods: {
    addInfo() {
      this.$refs.reminderSettingRef.openAdd();
    },
    updateData(row) {
      this.$refs.reminderSettingRef.openDetail(row);
    },
    deleteData(row) {
      this.$confirm(
        "是否确认删除监控预警设置?删除后将无法恢复该设置!",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        reminderDelete(row.configId).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.$refs.rvTableRef.initData();
          }
        });
      });
    },
    resetQuery() {
      this.alarmType = undefined;
      this.$refs.rvTableRef.initData();
    },
    handleQuery() {
      this.$refs.rvTableRef.initData();
    },
    getData(options) {
      this.isLoading = true;
      reminderQueryPage({
        pageNum: options.pageNum,
        pageSize: options.pageSize,
        alarmType: this.alarmType,
      })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.result.list;
            this.totalNum = res.result.total;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.data_wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.handle-input {
  width: 150px;
  display: inline-block;
}

.handle-select {
  width: 120px;
}

.searchBtn {
  height: 30px;
  background: #3b7bcf;
}

.etype {
  font-weight: bold;
  color: #212121;
}

.verticalCol {
  display: flex;
  flex-direction: column;
}

.myDrawer {
  width: 60%;
}

.dialog_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  color: #fff;
}

.btnOnline {
  color: #3b7bcf;
}

.btnOutLine {
  color: #8c939d;
}

.equipList {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.equipList span {
  color: #666666;
  font-size: 16px;
}
</style>